import React, { Suspense, lazy } from "react"
import { useAuth } from "@/features/auth"

const AgentDashboard = lazy(() => import("@/app/components/dashboards/AgentDashboard"))
const SalesManagerDashboard = lazy(() => import("@/app/components/dashboards/SalesManagerDashboard"))
const HRManagerDashboard = lazy(() => import("@/app/components/dashboards/HRManagerDashboard"))
const FMOCEODashboard = lazy(() => import("@/app/components/dashboards/FMOCEODashboard"))
const UserDashboard = lazy(() => import("@/app/components/dashboards/UserDashboard"))

function DashboardFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-pulse text-accent-600">Loading dashboard...</div>
    </div>
  )
}

export default function DashboardRouter() {
  const { user } = useAuth()

  if (!user) {
    return null
  }

  const handleError = (error: string) => {
    console.error("Dashboard error:", error)
  }

  let dashboard: React.ReactNode

  switch (user.role) {
    case "agent":
      dashboard = <AgentDashboard />
      break
    case "sales_manager":
      dashboard = <SalesManagerDashboard />
      break
    case "hr_manager":
      dashboard = <HRManagerDashboard onError={handleError} />
      break
    case "fmo_ceo":
      dashboard = <FMOCEODashboard />
      break
    case "user":
      dashboard = <UserDashboard />
      break
    case "admin":
      dashboard = <FMOCEODashboard />
      break
    default:
      return (
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-accent-900 mb-2">Unknown Role</h2>
            <p className="text-accent-600">Unable to determine dashboard for role: {user.role}</p>
          </div>
        </div>
      )
  }

  return <Suspense fallback={<DashboardFallback />}>{dashboard}</Suspense>
}
